/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { bidBiddersControllerRemove } from "./bidBiddersControllerRemove";
import { bidBiddersControllerUpdate } from "./bidBiddersControllerUpdate";
import { bidCellsControllerEdit } from "./bidCellsControllerEdit";
import { bidLevelingDecisionsControllerList } from "./bidLevelingDecisionsControllerList";
import { bidLevelingSampleDataControllerSeed } from "./bidLevelingSampleDataControllerSeed";
import { bidLevelingsControllerCreate } from "./bidLevelingsControllerCreate";
import { bidLevelingsControllerList } from "./bidLevelingsControllerList";
import { bidLevelingsControllerRead } from "./bidLevelingsControllerRead";
import { bidLevelingsControllerRemove } from "./bidLevelingsControllerRemove";
import { bidLevelingsControllerUpdate } from "./bidLevelingsControllerUpdate";
import { bidSubmissionsControllerCreate } from "./bidSubmissionsControllerCreate";
import { bidSubmissionsControllerList } from "./bidSubmissionsControllerList";
import { bidSubmissionsControllerRead } from "./bidSubmissionsControllerRead";
import { bidSubmissionsControllerUpdate } from "./bidSubmissionsControllerUpdate";

export function bidsService() {
  return { bidBiddersControllerUpdate, bidBiddersControllerRemove, bidCellsControllerEdit, bidLevelingsControllerList, bidLevelingsControllerCreate, bidLevelingsControllerRead, bidLevelingsControllerUpdate, bidLevelingsControllerRemove, bidLevelingDecisionsControllerList, bidLevelingSampleDataControllerSeed, bidSubmissionsControllerList, bidSubmissionsControllerCreate, bidSubmissionsControllerRead, bidSubmissionsControllerUpdate }
}